var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "上传个数限制" } },
        [
          _c("el-input-number", {
            attrs: { placeholder: "请输入最大上传个数", min: 1 },
            model: {
              value: _vm.uploadLimit,
              callback: function($$v) {
                _vm.uploadLimit = $$v
              },
              expression: "uploadLimit"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b77e078", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b77e078","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingUploadLimit.vue
// module id = null
// module chunks = 